<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdh-30px pdb-0 hauteur-haut-ressource">
      <div class="level border-entete">
        <div class="level-left">
          <p class="has-text-link is-size-4 has-text-weight-bold">
            {{ $t('chargeTravailAff.ressourceAndAffectationInfo.title') }}
          </p>
        </div>
        <div class="level-right is-cursor-pointer">
          <div @click="$emit('close')">
            <b-icon icon="close"
                    type="is-link"
                    size="is-small"
                    class="mgv-auto"></b-icon>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-8 pdv-0 has-text-default">
          <qd-switch :value="showLaisserEnPlace"
                    @input="$emit('updateShowLaisserEnPlace')">
            {{ $t('chargeTravailAff.showLc') }}
          </qd-switch>
          <qd-switch :value="nePasAfficherLc"
                    @input="$emit('updateNePasAfficherLc')">
            {{ $t('chargeTravailAff.nePasAfficherLc') }}
          </qd-switch>
        </div>
        <div class="column is-4 pdt-5px has-text-right">
          <button class="button is-addOrEdit"
                  :disabled="ressources.length === 0"
                  @click="checkPermissions(constantes.ORDRE_TRAVAIL.maj)
                      ? genererOT() : showPopUp()"
                  :class="{ 'button-access-no-permission'
                      : !checkPermissions(constantes.ORDRE_TRAVAIL.maj) }">
            {{ $t('chargeTravailAff.actions.generer')}}
          </button>
        </div>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless is-paddingless
    hauteur-ressource-information" v-if="ressources.length > 0">
      <error-msg-component :messages="messages" class="pdh-30px"
                           :error="messages.length > 0"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="messages = []"/>
      <div class="pdh-30px pdb-20px is-cursor-pointer"
           @click="$emit('updateAfficheurSelect', null)">
        <div :class="{ 'outline-primary-total' : afficheurSelect === null }"
             class="mgt-5px">
          <afficheurTitle :afficheurInformation="{
          afficheurId: null,
          afficheur: $t('chargeTravailAff.ressourceAndAffectationInfo.faceNonAffecte'),
          nbFaces: nbFaceSansTournee,
          }"
                          :firstLigne="true">
          </afficheurTitle>
        </div>
      </div>
      <div v-for="(afficheurInformation, index) in ressources" :key="index">
        <div class="pdh-30px pdb-20px">
          <div class="card"
            :class="{
              'outline-primary-total' :
                afficheurSelect === afficheurInformation.afficheurId
            }">
            <div class="is-cursor-pointer"
              v-on:click="$emit('updateAfficheurSelect', afficheurInformation.afficheurId)">
              <afficheurTitle v-if="afficheurInformation.afficheur"
                :firstLigne="false"
                :afficheurInformation="afficheurInformation"
                :nbListes="getListeAffichageByAfficheurId(afficheurInformation.afficheurId)">
              </afficheurTitle>
            </div>
            <div class="border-color-select border-top-none pd-0 is-cursor-pointer"
              v-for="(tournee, indexAffichage) of afficheurInformation.listeAffichage"
              :key="indexAffichage"
              @click="updateTournee(afficheurInformation.afficheurId, tournee.tourneeId)">
              <detail-tournee-affichage
                @reloadRessource="$emit('reloadRessource')"
                @errorGenerationOT="errorGenerationOT"
                @updateAfficheurSelect="$emit('updateAfficheurSelect',
                  afficheurInformation.afficheurId, tournee.tourneeId)"
                :dateDepart="tournee.dateDepart"
                :anneeSemaine="anneeSemaine"
                :societeActiveId="societeActiveId"
                :tourneeAffichage="tournee"
                :index="indexAffichage"
                :class="{'has-background-hoverTable' : tourneeSelect === tournee.tourneeId }">
              </detail-tournee-affichage>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="hauteur-ressource-information column is-12 pdh-30px is-flex">
      <div class="has-text-centered mgv-auto no-box-shadow-card width-100percent">
        <div  class="card card-content has-text-centered border-color-select">
          <h1 class="title is-size-4">
            {{ $t('chargeTravailAff.ressourceAndAffectationInfo.noCharge')}}
          </h1>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-ressourceAffectation">
      <button @click="$emit('close')"
              class="button mgt-15px is-size-7 has-text-link">
        {{ $t('general.button.close') }}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validation from '@/services/logistique/chargeTravail/affichage/validation';
import messageErreur from '@/services/general/messageErreur';
import detailTourneeAffichage
  from '@/components/logistique/chargeTravail/affichage/ressource/detailTourneeAffichage';
import afficheurTitle from '@/components/logistique/chargeTravail/affichage/ressource/afficheurTitle';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import { genererOrdreTravail } from '@/api/logistique/ordreTravailAffichage';
import messageSuccess from '@/services/general/messageSucces';

const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      messages: [],
      constantes: {
        ORDRE_TRAVAIL,
      },
    };
  },
  props: {
    ressources: {
      required: true,
      type: Array,
    },
    anneeSemaine: {
      required: true,
      type: Number,
    },
    nbFaceSansTournee: {
      required: true,
      type: Number,
    },
    showLaisserEnPlace: {
      required: true,
      type: Boolean,
    },
    societeActiveId: {
      required: true,
      type: String,
    },
    afficheurSelect: {
      required: false,
      type: String,
    },
    tourneeSelect: {
      required: false,
      type: String,
    },
    nePasAfficherLc: {
      required: true,
      type: Boolean,
    },
  },
  components: {
    afficheurTitle,
    errorMsgComponent,
    detailTourneeAffichage,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async genererOT() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let tfsIds = [];
        this.messages = [];
        this.ressources.forEach((ressource) => {
          ressource.listeAffichage
            .filter(tournee => tournee.ordreTravailId === null)
            .map(tournee => tournee.ids).forEach((ids) => {
              tfsIds = tfsIds.concat(ids);
            });
        });
        if (tfsIds.length > 0) {
          await genererOrdreTravail({
            anneeSemaine: this.anneeSemaine,
            societeId: this.societeActiveId,
            tfsIds: tfsIds,
          });
          messageSuccess(this.$t('chargeTravailAff.messages.sucess.otCreate'));
          this.$emit('reloadRessource');
        } else {
          this.messages.push({ message: 'chargeTravailAff.messages.errors.noOt' });
        }

        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        this.errorGenerationOT();
        throw e;
      }
    },
    getListeAffichageByAfficheurId(id) {
      const ressource = this.ressources.filter(resource => resource.afficheurId === id);
      const nbListe = ressource.reduce((acc, val) => {
        return acc + val.listeAffichage.length;
      }, 0);
      return nbListe;
    },
    errorGenerationOT(error) {
      if (error.response.data.error) {
        this.messages = [];
        validation(error.response, this.messages);
      } else messageErreur(this.$i18n);
    },
    updateTournee(afficheurId, tourneeId) {
      this.$emit('updateAfficheurSelect', afficheurId, tourneeId);
    },
  },
};
</script>
